<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Data Kredensial</section>

    <!-- Body -->
    <div class="w-full p-5">
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Username"
              v-model="updateData.username"
              name="username"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('username')">{{
              errors.first("username")
            }}</span>
            <span class="text-danger text-sm" v-show="!usernameStatus">{{
              usernameErrorMsg
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              type="password"
              label-placeholder="Password Baru"
              v-model="updateData.password"
              name="password"
              v-validate="'required|min:8'"
            />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{
              errors.first("password")
            }}</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="submit"
        >
          Update
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="cancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>

import {UPDATE_CREDENTIAL} from '@/query/login';
import {CHECK_USERNAME} from '@/query/login';

export default {
  props: {
     pengguna: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      updateData: {
        username: this.pengguna.login.username,
        password: ""
      },
      usernameStatus: true,
      usernameErrorMsg: "",
      lock: ""
    };
  },
  methods: {
    async submit() {
      await this.$validator.validateAll().then(result => {
        if (result && this.usernameStatus) {
          this.$apollo
            .mutate({
              mutation: UPDATE_CREDENTIAL,
              variables: {
                id: this.pengguna.login.id,
                input: {
                  ...this.updateData
                }
              }
            })
            .then(() => {
              this.$vs.notify({
                title: "Berhasil melakukan update kredensial.",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right"
              });
              window.setTimeout(() => {
                this.toggleActive(false);
                this.submitCallback();
                this.$emit("submitCallback", true);
              }, 700);
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          this.$vs.notify({
            title: "Untuk memperbaharui data, silahkan lengkapi form terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },
    async checkUsername() {
      clearTimeout(this.lock);
      this.lock = setTimeout(() => {
        this.checkUsernameCharacters() == true
          ? this.checkUsernameAvailability()
          : "";
      }, 700);
    },
    checkUsernameCharacters() {
      var regex = /^[A-Za-z0-9 ]+$/;
      if (
        !regex.test(this.updateData.username) ||
        this.updateData.username.indexOf(" ") >= 0
      ) {
        this.usernameStatus = false;
        this.usernameErrorMsg =
          "Username tidak boleh berisi spasi & karakter spesial !";
        return false;
      } else {
        return true;
      }
    },
    checkUsernameAvailability() {
      this.$apollo
        .query({
          query: CHECK_USERNAME,
          variables: {
            id: this.pengguna.login.id,
            username: this.updateData.username
          }
        })
        .then(response => {
          if (response.data.checkUsername != null) {
            this.usernameStatus = false;
            this.usernameErrorMsg =
              "Username sudah digunakan, silahkan masukan username yang lain !";
          } else {
            this.usernameStatus = true;
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: "Terjadi kesalahan, silahkan hubungi tim IT.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        });
    },
    cancel() {
      this.toggleActive(false);
    },
    submitCallback() {
      this.$emit("submitCallback", true);
    },
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
      this.updateData.password = '';
    },
  },
  watch: {
    "updateData.username": function() {
      this.updateData.username.length > 4 ? this.checkUsername() : "";
    }
  }
};
</script>
